import { useDispatch, useSelector } from "react-redux"
import {
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import {
  setIsCreditNote,
  setNewEntryMode,
  setDetailParams,
  resetDetailParams,
} from "../../state/creditDebitNoteSlice"
import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { resetReportDetail, setInvoiceDetail } from "../../state/invoiceSlice"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"

const InvoiceDataList = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { token, user } = useSelector((state) => state.auth)
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  //let [data, setData] = useState([])

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
    disapatch(resetDetailParams())
  }, [])

  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()

  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.transaction.creditdebitnote.fetchInvoice,
    queryKey: "Credit Invoice Data List",

  })
  //console.log(GetLoginCredentialDb())
  const funFilterData = () => {
    filterData({
      data: {
        compcode: compCode.join(","),
        db_user: GetLoginCredentialDb(user, yearId)
      }
    })
  }

  useEffect(() => {
    funFilterData();
  }, [])


  const onSuccessDelete = (data) => {
    setItemToDelete("")
    toast.success("deleted successfully", {
      position: "top-center"
    })
    funFilterData();
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.transaction.creditdebitnote.deleteNote,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "invoice_amount",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "party_name",
    "invoice_no",
    "invoice_amount",
    "invoice_date",
    "account_name",

  ]

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
    },
    {
      name: "DATE",
      uid: "invoice_date",
      type:COLUMN_TYPE.date
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
    },
  ]

  let downloadDataFooter = {
    party_name: "",
    invoice_no: "",
    invoice_amount: "Total: " + totalAmt,
    invoice_date: "",
    account_name: "",
  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "party_name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {
      FndeleteNote({
        data: {
          transaction_id: itemToDelete.transaction_id,
          comp_code: itemToDelete.comp_code,
        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        let obj = {
          //token: token,
          comp_code: row.compcode,
          transaction_id: row.TransactionId,
          //db_user: GetLoginCredentialDb(user, yearId)
        }
        //  disapatch(setCreditNoteInvoiceDetail(obj))
        disapatch(setDetailParams(obj))
        disapatch(setIsCreditNote(true))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.transaction.creditDebitEntry.creditdebitnote)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {

        setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.compcode, trn_no: row.Trn_No })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#0a4da6" icon={faReceipt} />,
      onClick: (row) => {
        let obj = {
          token: token,
          comp_code: row.compcode,
          acid: null,
          billno: row.invoice_no,
          billtype: "V",
          db_user: GetLoginCredentialDb(user, yearId)
        }
        disapatch(resetReportDetail())
        disapatch(setInvoiceDetail(obj))
        onOpenReportModel()
      },
      label: "print",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.transaction.creditDebitEntry.creditdebitnote)
  }

  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="xl"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-row gap-1">
                  Credit / Debit Note
                </ModalHeader>
                <ModalBody className="overflow-auto ">
                  <div className="flex flex-col">
                    <ReportViewer props_ReportType={enum_Report_Type.DBCRNote} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }

  return (
    <div>
      {reportModel()}
      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName="Credit/Debit Note"
        info={[]}
        breadcrumbs={["Transaction", "Credit Debit Note"]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onClick={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          // handleDataChange={handleDataChange}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="CreditDebitNote-List"
          showAdvanceFilter={false}
          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default InvoiceDataList
